import { render, staticRenderFns } from "./RssWidget.vue?vue&type=template&id=77bbb045&scoped=true"
import script from "./RssWidget.vue?vue&type=script&lang=js"
export * from "./RssWidget.vue?vue&type=script&lang=js"
import style0 from "./RssWidget.vue?vue&type=style&index=0&id=77bbb045&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bbb045",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77bbb045')) {
      api.createRecord('77bbb045', component.options)
    } else {
      api.reload('77bbb045', component.options)
    }
    module.hot.accept("./RssWidget.vue?vue&type=template&id=77bbb045&scoped=true", function () {
      api.rerender('77bbb045', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/viewer/templateWidgets/RssWidget.vue"
export default component.exports